import isEqual from 'react-fast-compare';

type Arguments = Array<unknown>;
/**
 * Return a function that behaves the same as `fn`, except that if a subsequent call to `fn`
 * returns a value that is deep equal to the last return value, then it returns the previous return
 * value instead, thus preserving shallow equality between subsequent function calls.
 *
 * Intended for use in contexts like React where performance depends on shallow equality between
 * subsequent values. Should ONLY be used when that performance gain is expected to be more
 * significant than the cost of computing deep equality between the outputs.
 */
export default function preserveShallowEquality<A extends Arguments, R>(
  fn: (...args: A) => R
): (...args: A) => R {
  let lastRetVal: R | null = null;
  return (...args) => {
    let nextRetVal: R = fn(...args);
    // eslint-disable-next-line benchlint/no-eqeqeq-null
    if (lastRetVal !== null && isEqual(lastRetVal, nextRetVal)) {
      nextRetVal = lastRetVal;
    }

    lastRetVal = nextRetVal;
    return nextRetVal;
  };
}
